import type { ReactNode } from "react";

type TableHeaderProps = {
  children: ReactNode;
};

function TableHeaderRoot({ children }: TableHeaderProps) {
  return (
    <div className="flex items-center flex-wrap gap-y-2 xs:gap-y-4 gap-x-2 sm:gap-x-4 justify-between pb-2 w-full">
      {children}
    </div>
  );
}

export default TableHeaderRoot;
